import { render, staticRenderFns } from "./NuevoTope.vue?vue&type=template&id=6e0ab2c6&scoped=true"
import script from "./NuevoTope.vue?vue&type=script&lang=js"
export * from "./NuevoTope.vue?vue&type=script&lang=js"
import style0 from "./NuevoTope.vue?vue&type=style&index=0&id=6e0ab2c6&prod&scoped=true&lang=css"
import style1 from "./NuevoTope.vue?vue&type=style&index=1&id=6e0ab2c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0ab2c6",
  null
  
)

export default component.exports